module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.numberOfOffers > 0) ? _c('div', {
    staticClass: "offers-header"
  }, [_c('div', {
    staticClass: "offers-header__icon"
  }, [_c('svg', {
    attrs: {
      "width": "25",
      "height": "30",
      "viewBox": "0 0 1792 1792"
    }
  }, [_c('path', {
    attrs: {
      "d": "M576 448q0-53-37.5-90.5t-90.5-37.5-90.5 37.5-37.5 90.5 37.5 90.5 90.5 37.5 90.5-37.5 37.5-90.5zm1067 576q0 53-37 90l-491 492q-39 37-91 37-53 0-90-37l-715-716q-38-37-64.5-101t-26.5-117v-416q0-52 38-90t90-38h416q53 0 117 26.5t102 64.5l715 714q37 39 37 91z"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "offers-header__title"
  }, [_c('strong', [_vm._v(_vm._s(_vm.numberOfOffers) + " " + _vm._s(_vm.$tc('offers_stage.offers_available', _vm.numberOfOffers)))])]), _vm._v(" "), _c('div', {
    staticClass: "offers-header__button",
    on: {
      "click": _vm.toggleOffers
    }
  }, [(_vm.shouldDisplay) ? _c('span', [_vm._v(_vm._s(_vm.$t('offers_stage.hide_offers')))]) : _vm._e(), _vm._v(" "), (!_vm.shouldDisplay) ? _c('span', [_vm._v(_vm._s(_vm.$t('offers_stage.see_offers')))]) : _vm._e()])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-791da32e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/offersHeader.vue
// module id = 606
// module chunks = 0